var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"type":"number","value":_vm.value},on:{"input":function($event){_vm.$emit('input', parseFloat($event))}}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }